import React from 'react';
import PropTypes from 'prop-types';
import Quickstart from './Quickstart';

class QuickstartList extends React.Component {

  loadCarousel(element) {
    const { onHomePage } = this.props;

    const responsive = onHomePage
    ? {
      0: { items: 1, stagePadding: 50, center: true },
      380: { items: 1, stagePadding: 70, center: true },
      570: { items: 2, stagePadding: 70, center: true },
      768: { items: 4, stagePadding: 0, center: false, mouseDrag: false, touchDrag: false },
      880: { items: 4, stagePadding: 0, center: false, mouseDrag: false, touchDrag: false }
    } :
    {
      0: { items: 1, stagePadding: 60, center: true },
      380: { items: 2, stagePadding: 0, center: true },
      570: { items: 3, stagePadding: 0, center: true },
      768: { items: 4, stagePadding: 0, center: false, mouseDrag: false, touchDrag: false },
      880: { items: 4, stagePadding: 0, autoWidth: true, center: false, mouseDrag: false, touchDrag: false }
    };

    if (typeof window !== 'undefined') {
      const $carousel = $(element);
      $carousel.owlCarousel({
        margin: 20,
        center: true,
        dots: true,
        navContainerClass: 'nav-carousel',
        navClass: ['prev', 'next'],
        navText: ['', ''],
        baseClass: 'js-carousel',
        itemClass: 'item',
        dotsClass: 'dots',
        dotClass: 'dot',
        nav: false,
        responsive,
        onChanged: (change) => {
          const toggleCarousel = (target, hide) => {
            if (hide) {
              $(target).children('.nav-carousel').hide();
            } else {
              $(target).children('.nav-carousel').show();
            }
          };

          if (onHomePage) {
            const width = change.currentTarget.scrollWidth;

            if (width < 768) {
              if (width >= 570) {
                const endOfCarousel = change.item.index >= 2;
                toggleCarousel(change.currentTarget, endOfCarousel);
              } else {
                const endOfCarousel = change.item.index >= 3;
                toggleCarousel(change.currentTarget, endOfCarousel);
              }
            }
          }
        }
      });
    }
  }

  render() {
    const { quickstarts, isFramedMode } = this.props;

    let carousel = null;
    let items = null;
    let hide = 'hide ';

    if (quickstarts) {
      hide = '';
      items = Object.keys(quickstarts).map(name => (
        <Quickstart
          key={name}
          quickstart={quickstarts[name]}
          isFramedMode={isFramedMode}
        />
      ));
    }

    if (isFramedMode) {
      carousel = <div className="js-carousel">{items}</div>;
    } else {
      carousel = <div className="js-carousel" ref={this.loadCarousel.bind(this)}>{items}</div>;
    }

    return (
      <div className={`${hide} quickstart-list container`}>
        {carousel}
      </div>
    );
  }

}

QuickstartList.propTypes = {
  quickstarts: PropTypes.object,
  isFramedMode: PropTypes.bool.isRequired,
  onHomePage: PropTypes.bool
};

export default QuickstartList;
